


























































































































































































































































































































































































































































































































import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { ReservationModel } from "./types";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import { FinancialSettingsType } from "@/store/modules/financial";
import { Getter, Action } from "vuex-class";
import { DateTime } from "luxon";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import DateField from "@/components/misc/DateField.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import { Currency } from "@/shared/models/currency";
import { DistributionChannelTypesEnum } from "@/components/reservation-form/types";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import { ServiceType } from "@/shared/models/serviceType";
import _ from "lodash";
import { parseStringToDateJS } from "@/shared/dateFormatUtils";
import { InvoiceStatusEnum, TenantTypesEnum } from "@/shared/models/enums.type";
import { round } from "@/components/numbers/numberFormatUtils";

@Component({
  components: {
    CurrencyDisplay,
    NumericInputImproved,
    DateField,
    RequireRole,
  },
})
export default class ReservationFormPrice extends Vue {
  @PropSync("reservation", { default: undefined }) model?: ReservationModel;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") financialSettings?: FinancialSettingsType;
  @Getter("codebooks/currencies") currencies?: Currency[];
  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes")
  serviceTypes?: ServiceType[];
  @Getter("appParams/typeId") tenantTypeId?: number;
  @Getter("appParams/tenantUsesAgencyFees") tenantUsesAgencyFees?: boolean;

  get currencyId() {
    const ids =
      this.model?.accomodationUnitTypes
        .map((x) => x.ratePlan?.currencyId)
        .filter((x) => x != undefined) ?? [];
    if (ids.length > 0) {
      return ids[0];
    }

    return this.financialSettings?.workingCurrency.id;
  }

  get currencyIsoCode() {
    const currency = this.currencies?.find((x) => x.id == this.currencyId);
    return (
      currency?.isoCode ??
      this.financialSettings?.workingCurrency.isoCode ??
      "EUR"
    );
  }

  get isOwnerLevel3() {
    return policyChecker("OWNER_LEVEL_3")(this.claims);
  }

  get isTenantAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get formalCurrencyIsoCode() {
    return this.financialSettings?.formalCurrency.isoCode ?? "HRK";
  }

  @Prop() isMobile?: boolean;

  DistributionChannelTypesEnum = DistributionChannelTypesEnum;

  overriding = false;
  policiesDialog = false;
  policiesLoading = false;
  maxCancellationDate = "";
  cancelationPenalties = [] as any[];
  prepaymentFees = [] as any[];

  @Ref("cancelationOverrideForm") cancelationOverrideForm?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };
  @Ref("prepaymentOverrideForm") prepaymentOverrideForm?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  prepaymentOverrideAmount = 0;
  prepaymentOverrideDate = "";

  cancelationOverrideAmount = 0;
  cancelationOverrideDate = "";

  get reservationExists() {
    return !!this.model?.id;
  }

  get hasOverrides() {
    return (
      this.model?.hasPrepaymentOverride || this.model?.hasCancelationOverride
    );
  }

  get isBookingOnArrivalDate() {
    return (
      parseStringToDateJS(this.model?.bookingDate.toString() ?? "")
        .toISOString()
        .substring(0, 10) ===
      parseStringToDateJS(
        this.model?.arrivalDate ? this.model.arrivalDate.toString() : ""
      )
        .toISOString()
        .substring(0, 10)
    );
  }

  @Getter("auth/claims") claims?: JwtClaims;
  get canEditPrices() {
    return policyChecker("MODIFY_RESERVATION_PRICES")(this.claims);
  }

  @Watch("policiesDialog")
  async policiesDialogWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      const requestModel = this.model?.accomodationUnitTypes.map((x) => {
        return {
          arrivalDate: x.arrivalDate,
          bookingDate: this.model?.bookingDate,
          ratePlanId: x.ratePlan?.id,
          dayPrices: x.dayPrices.map((p) => p.price),
          discountPercent: x.discountPercent ?? 0,
          services: x.selectedServices.map((s) => {
            return {
              price:
                this.currencyConversionService?.convertCurrency(
                  s.grossPrice,
                  s.currencyId,
                  this.currencyId ?? s.currencyId
                ) ?? s.grossPrice,
              isCityTax: s.isCityTax,
              isBookingFee: s.isBookingFee,
              isAddedAutomatically: s.isAddedAutomatically,
            };
          }),
        };
      });

      this.cancelationPenalties = [];
      this.prepaymentFees = [];
      this.policiesLoading = true;
      this.overriding = false;

      const promises = [];

      if (this.model?.id && this.model?.hasCancelationOverride) {
        promises.push(
          Vue.axios.get<any[]>(
            `reservations/${this.model.id}/CancelationPolicies`
          )
        );
      } else {
        promises.push(
          Vue.axios.post<any[]>("reservations/GetCancelationPoliciesPreview", {
            cancelationPolicies: requestModel,
          })
        );
      }

      if (this.model?.id && this.model?.hasPrepaymentOverride) {
        promises.push(
          Vue.axios.get<any[]>(
            `reservations/${this.model.id}/PrepaymentPolicies`
          )
        );
      } else {
        promises.push(
          Vue.axios.post<any[]>("reservations/GetPrepaymentPoliciesPreview", {
            prepaymentPolicies: requestModel,
          })
        );
      }

      const [cancelation, prepayment] = await Promise.all(promises);

      this.cancelationPenalties = cancelation.data;
      this.prepaymentFees = prepayment.data;

      this.policiesLoading = false;
    }
  }

  async checkForSuspiciousCancellations() {
    let isCancellationAmountBiggerAndFromDateLater = false;

    this.cancelationPenalties.forEach((x) => {
      this.cancelationPenalties.forEach((y) => {
        if (x.amount < y.amount && x.effectiveFrom > y.effectiveFrom) {
          isCancellationAmountBiggerAndFromDateLater = true;
          return;
        }
      });
    });

    if (isCancellationAmountBiggerAndFromDateLater) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("Cancellation.AmountInTheFutureWarning"),
        actions: [
          {
            text: this.$t("Save"),
            fun: () => {
              this.submitOverride();
              return true;
            },
          },
          {
            text: this.$t("Cancel"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 30000,
      } as unknown as Notification);
    } else {
      this.submitOverride();
    }
  }

  async submitOverride() {
    const cFormValid = this.cancelationOverrideForm?.validate();
    const pFormValid = this.prepaymentOverrideForm?.validate();
    const prepaymentsList: {
      dueDate: string;
      amount: number;
      currencyId: number | null | undefined;
    }[] = [];
    const cancelationsList: {
      effectiveFrom: string;
      effectiveUntil: string;
      amount: number;
      currencyId: number | null | undefined;
    }[] = [];

    if (!cFormValid || !pFormValid) return;

    this.policiesLoading = true;

    try {
      const until =
        this.model?.departureDate?.toJSON().substring(0, 10) ??
        DateTime.local()
          .plus({ years: 10 }) // arbitrary
          .toJSON()
          .substring(0, 10);

      if (this.prepaymentFees.length > 0) {
        this.prepaymentFees.forEach((x) =>
          prepaymentsList.push({
            dueDate: x.dueDate,
            amount: x.amount,
            currencyId: this.model?.currencyId,
          })
        );
      }

      if (this.cancelationPenalties.length > 0) {
        this.cancelationPenalties.forEach((x) =>
          cancelationsList.push({
            effectiveFrom: x.effectiveFrom,
            effectiveUntil: until,
            amount: x.amount,
            currencyId: this.model?.currencyId,
          })
        );
      }

      const reqModel = {
        reservationId: this.model?.id,
        prepayment: prepaymentsList,
        cancelation: cancelationsList,
      };

      await this.axios.post(`reservations/OverridePolicies`, reqModel);

      if (this.model) {
        this.model.hasCancelationOverride = true;
        this.model.hasPrepaymentOverride = true;
      }
      this.policiesDialog = false;
    } finally {
      this.policiesLoading = false;
    }
  }

  async clearOverrides() {
    this.policiesLoading = true;
    try {
      await Vue.axios.post<any>("reservations/ClearOverridePolicies", {
        reservationId: this.model?.id,
      });

      if (this.model) {
        this.model.hasCancelationOverride = false;
        this.model.hasPrepaymentOverride = false;
      }

      this.policiesDialog = false;
    } finally {
      this.policiesLoading = false;
    }
  }

  freeCancelationUntil() {
    if (this.cancelationPenalties && this.cancelationPenalties.length > 0) {
      const date = DateTime.fromISO(
        this.cancelationPenalties[0].effectiveFrom
      ).plus({ minutes: -1 });
      return date;
    }

    if (this.model?.arrivalDate) {
      return DateTime.fromJSDate(this.model?.arrivalDate)
        .set({ hour: 0 })
        .plus({ minutes: -1 });
    }
  }

  cancelationFrom(penalty: any) {
    const date = DateTime.fromISO(penalty.effectiveFrom);
    return date;
  }

  cancelationTo(cancelationPenalties: any[], index: number) {
    const date = DateTime.fromISO(
      cancelationPenalties[index + 1].effectiveFrom
    ).plus({ minutes: -1 });
    return date;
  }

  feeDueDate(fee: any) {
    const date = DateTime.fromISO(fee.dueDate)
      .plus({ days: 1 })
      .plus({ minutes: -1 });
    return date;
  }

  get totalUnitPrices() {
    return (
      (this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          round(
            acc.dayPrices.reduce((dsum, d) => dsum + d.price, 0) *
              (1 - round((acc.discountPercent ?? 0) / 100, 8))
          ),
        0
      ) || 0) + this.mergedCityTaxPrice()
    );
  }

  mergedCityTaxPrice() {
    return (
      this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          acc.selectedServices
            .filter((x) => x.isCityTax)
            .reduce(
              (ssum, s) =>
                this.serviceTypes?.find(
                  (x) => x.id == _.first(acc.dayPrices)?.serviceTypeId
                )?.includesCityTax === true
                  ? ssum +
                    (this.currencyConversionService?.convertCurrency(
                      s.grossPrice,
                      s.currencyId,
                      this.currencyId ?? s.currencyId
                    ) ?? s.grossPrice)
                  : ssum,
              0
            ),
        0
      ) || 0
    );
  }

  deletePolicy(isCancelation: boolean, index: any) {
    if (isCancelation) this.cancelationPenalties.splice(index, 1);
    else this.prepaymentFees.splice(index, 1);
  }

  addPolicy(isCancelation: boolean) {
    const startingDate = new Date();
    startingDate.setUTCHours(0, 0, 0, 0);

    if (isCancelation) {
      this.cancelationPenalties.push({
        effectiveFrom: startingDate.toISOString().substring(0, 19),
      });
    } else {
      this.prepaymentFees.push({
        dueDate: startingDate.toISOString().substring(0, 19),
      });
    }
  }

  get ownerFee() {
    return (
      this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          round(
            acc.dayPrices.reduce((owner, s) => owner + s.inputPrice, 0) *
              (1 - round((acc.discountInputPercent ?? 0) / 100, 8)),
            2
          ),
        0
      ) || 0
    );
  }

  get ownerTotalPrice() {
    return this.ownerAOSPrice + this.ownerAccPrice;
  }

  get ownerAOSPrice() {
    return (
      this.model?.accomodationUnitTypes.reduce(
        (sum, acc) => sum + (acc.ownerAddOnServicesPrice ?? 0),
        0
      ) || 0
    );
  }

  get ownerAccPrice() {
    return (
      (this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          round(
            acc.dayPrices.reduce((dsum, d) => dsum + d.inputPrice, 0) *
              (1 - (acc.discountInputPercent ?? 0) / 100)
          ),
        0
      ) || 0) - (this.agencyFee ?? 0)
    );
  }

  get agencyMarginAmount() {
    return this.totalUnitPrices - this.ownerTotalPrice;
  }

  get agencyMarginPercentage() {
    return round((this.agencyMarginAmount / this.totalUnitPrices) * 100);
  }

  get otaFee() {
    return this.model?.accomodationUnitTypes.reduce(
      (sum, x) => sum + (x.channelCommission ?? 0),
      0
    );
  }

  get agencyFee() {
    return this.model?.accomodationUnitTypes.reduce(
      (sum, x) =>
        sum +
        (x.agencyFeesTotal ?? 0) +
        (x.ownerPaysOTACommission ? x.channelCommission ?? 0 : 0),
      0
    );
  }

  get cityTax() {
    return (
      this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          acc.selectedServices
            .filter((s) => s.isCityTax)
            .reduce(
              (tax, s) =>
                tax +
                (this.currencyConversionService?.convertCurrency(
                  s.grossPrice,
                  s.currencyId,
                  this.financialSettings?.formalCurrency.id ?? 0
                ) ?? 0),
              0
            ),
        0
      ) || 0
    );
  }

  get otherFees() {
    return (
      this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          acc.selectedServices
            .filter((s) => !s.isCityTax && s.isFee)
            .reduce(
              (ssum, s) =>
                ssum +
                (this.currencyConversionService?.convertCurrency(
                  s.grossPrice,
                  s.currencyId,
                  this.currencyId ?? s.currencyId
                ) ?? s.grossPrice),
              0
            ),
        0
      ) || 0
    );
  }

  get services() {
    return (
      this.model?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          acc.selectedServices
            .filter((s) => !s.isCityTax && !s.isFee)
            .reduce(
              (ssum, s) =>
                ssum +
                (this.currencyConversionService?.convertCurrency(
                  s.grossPrice,
                  s.currencyId,
                  this.currencyId ?? s.currencyId
                ) ?? s.grossPrice),
              0
            ),
        0
      ) || 0
    );
  }

  get totalServicePrice() {
    const isAllowedOnlyInputPrices = policyChecker("INPUT_PRICES")(this.claims);
    return !isAllowedOnlyInputPrices
      ? this.model?.accomodationUnitTypes.reduce(
          (sum, acc) =>
            sum +
            acc.selectedServices
              .filter(
                (x) =>
                  !x.isCityTax ||
                  !this.serviceTypes?.find(
                    (x) => x.id == _.first(acc.dayPrices)?.serviceTypeId
                  )?.includesCityTax
              )
              .reduce(
                (ssum, s) =>
                  ssum +
                  (this.currencyConversionService?.convertCurrency(
                    s.grossPrice,
                    s.currencyId,
                    this.currencyId ?? s.currencyId
                  ) ?? s.grossPrice),
                0
              ),
          0
        ) || 0
      : this.model?.accomodationUnitTypes.reduce(
          (sum, acc) => sum + (acc.ownerAddOnServicesPrice ?? 0),
          0
        ) || 0;
  }

  get totalPrice() {
    return this.totalUnitPrices + this.totalServicePrice;
  }

  get invoiced() {
    return round(this.totalPrice, 2) - (this.model?.amountToInvoice ?? 0);
  }

  get remaining() {
    return this.model?.amountToInvoice ?? 0;
  }

  get invoiceStatus() {
    return InvoiceStatusEnum[this.model?.invoiceStatusId ?? 5];
  }

  get isFullyInvoiced() {
    if (this.model?.invoiceStatusId === InvoiceStatusEnum.FullyInvoiced) {
      return true;
    } else {
      return false;
    }
  }

  currencyConversionService?: CurrencyConversionService;
  async created() {
    const promises = [];

    if (!this.financialSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }
    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      promises.push(this.refreshServiceTypes());
    }

    await Promise.all(promises);

    if (this.financialSettings) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      noNegativeNumbers: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
    };
  }

  noExistingDates(value: any) {
    if (value !== undefined) {
      return this.cancelationPenalties
        .filter((x) => x != value)
        .some(
          (x) =>
            x.effectiveFrom.substring(0, 10) ==
            value.effectiveFrom.substring(0, 10)
        )
        ? this.$t("Cancellations.Validation.MultipleCancellationsOnSameDay")
        : true;
    } else {
      return true;
    }
  }

  getPrepaymentPaymentStatus(prepaymentFees: any[], feeIndex: number) {
    const total = prepaymentFees
      .filter((a, b) => b <= feeIndex)
      .reduce((sum, e) => sum + e.amount, 0);
    const totalOfPrevious = prepaymentFees
      .filter((a, b) => b < feeIndex)
      .reduce((sum, e) => sum + e.amount, 0);
    const totalPaid = this.model?.totalPaidByGuest ?? 0;
    const today = new Date().toISOString().substring(0, 10);
    const feeDueDate = prepaymentFees[feeIndex].dueDate.substring(0, 10);
    if (total <= totalPaid) {
      return {
        status: this.$t("PrepaymentPolicy.PaymentStatus.Paid"),
        color: "success",
      };
    } else if (
      totalOfPrevious <= totalPaid &&
      totalPaid - totalOfPrevious > 0
    ) {
      return {
        status: this.$t("PrepaymentPolicy.PaymentStatus.PartiallyPaid"),
        color: "warning",
      };
    } else if (feeDueDate < today) {
      return {
        status: this.$t("PrepaymentPolicy.PaymentStatus.Unpaid"),
        color: "error",
      };
    } else {
      return {
        status: this.$t("PrepaymentPolicy.PaymentStatus.Upcoming"),
        color: "",
      };
    }
  }
}
